import script from "./SupplierForecastDashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupplierForecastDashboard.vue?vue&type=script&lang=ts&setup=true"

import "./SupplierForecastDashboard.vue?vue&type=style&index=0&id=04deb3bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04deb3bc"]])

export default __exports__